import { ABOUT_PATH, SUBPAGE_PATH } from "../pages/About/paths.js";

const SITE_URL = "https://talesandlegends.org";

/**
 * Author register for buildArticleJsonLd's Person schema (§ finding 7,
 * E-E-A-T) and the visible "about the author" block under LARP-Wissen
 * articles — keyed by the exact `author` frontmatter string used in
 * content/*.md. Facts confirmed directly by Nils, not inferred from the
 * org's own founding date (Tales&Legends gUG is new — his personal
 * LARP/theater experience predates it) — same no-fabrication rule as
 * Impressum/team bios (no invented years, event counts, or credentials).
 */
export const AUTHORS = {
  "Nils Jäkel": {
    bio: {
      de: "Nils Jäkel organisiert seit fünf Jahren Sommertheater-Events und besucht seit ebenso langer Zeit LARP-Veranstaltungen; seit vier Jahren ist er zudem Lagerorga in einem der größten Lager auf dem Conquest of Mythodea, dem größten LARP-Event der Welt. Vier Jahre lang leitete er einen Theaterverein als Vorstand, seit zwei Jahren ist er zudem Vorstandsvorsitzender des Landesverbands für Amateurtheater Sachsen.",
      en: "Nils Jäkel has organized summer-theater events for five years and has attended LARP events for the same span; for four years he has also been a camp organizer at one of the largest camps at Conquest of Mythodea, the world's largest LARP event. He spent four years chairing a theater association's board, and for the past two years has served as board chair of the State Association for Amateur Theater Saxony (Landesverband für Amateurtheater Sachsen).",
    },
    sameAs: ["https://www.linkedin.com/in/njaekel/", "https://www.instagram.com/bygahrt/"],
    url: (lang) => `${SITE_URL}${teamPath(lang)}`,
    teamPath,
  },
};

function teamPath(lang) {
  return `/${lang}/${ABOUT_PATH[lang]}/${SUBPAGE_PATH.team[lang]}`;
}
